import styled from 'styled-components';

export const LoaderContainer = styled.div`
    width: 100%;
    height: 100vh;
    background-color: #121212;

`;